import ReactDOM from 'react-dom';
import React, { PureComponent } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";


const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: "90%",
        margin: "auto"
    },
    paper: {
        maxHeight: "85%",
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    reactCrop: {
        maxWidth: "50%",
        [theme.breakpoints.down('sm')]: {
            maxWidth: "100%"
        },
        '& .ReactCrop__image': {
            maxHeight: "65vh",
            [theme.breakpoints.down('sm')]: {
                maxHeight: "30vh"
            },
        }
    },
    imagesContainer: {
        
    },
    croppedImage: {
        maxWidth: '35%', 
        marginLeft: "15px",
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            marginLeft: "0px",
        },
    },
});


class ImageCrop extends PureComponent {
    state = {
        open: false,
        src: null,
        crop: {
            unit: '%',
            width: 30,
            aspect: 800 / 456
        },
    };

    onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const reader = new FileReader();
            reader.addEventListener('load', () =>
                this.setState({ src: reader.result, open: true })
            );
            reader.readAsDataURL(e.target.files[0]);
        }
    };

    // If you setState the crop in here you should return false.
    onImageLoaded = (image) => {
        this.imageRef = image;
    };

    onCropComplete = (crop) => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    onModalClose = () => {
        this.setState({ open: false })
    };

    onCancel = () => {
        this.props.handleImageChange(null);
        this.setState({ open: false });
        document.getElementById("imageFile").value = "";
    };

    async makeClientCrop(crop) {
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            this.setState({ croppedImageUrl });
        }
    }

    getCroppedImg(image, crop, fileName) {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        return new Promise((resolve, reject) => {
            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        //reject(new Error('Canvas is empty'));
                        console.error('Canvas is empty');
                        return;
                    }
                    blob.name = fileName;
                    this.props.handleImageChange(blob);
                    window.URL.revokeObjectURL(this.fileUrl);
                    this.fileUrl = window.URL.createObjectURL(blob);
                    resolve(this.fileUrl);
                },
                'image/jpeg',
                1
            );
        });
    }

    render() {
        const { crop, croppedImageUrl, src, open } = this.state;
        const { classes } = this.props;

        return (
            <div className="App">
                <div>
                    <input id="imageFile" type="file" accept="image/*" onChange={this.onSelectFile} />
                </div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={this.onModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <div className={classes.imagesContainer}>
                                {src && (

                                    <ReactCrop
                                        className={classes.reactCrop}
                                        src={src}
                                        crop={crop}
                                        ruleOfThirds
                                        onImageLoaded={this.onImageLoaded}
                                        onComplete={this.onCropComplete}
                                        onChange={this.onCropChange}
                                    />

                                )}
                                {croppedImageUrl && (
                                    <img alt="Crop" className={classes.croppedImage} src={croppedImageUrl} />
                                )}
                            </div>

                            <Button
                                className={classes.btn}
                                variant="contained"
                                fullWidth
                                onClick={this.onModalClose}
                            >
                                Confirm
                            </Button>
                            <Button
                                className={classes.btn}
                                variant="contained"
                                fullWidth
                                onClick={this.onCancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </Fade>
                </Modal>
            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(ImageCrop);